import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import {
	Card as CardToolkit,
	Label,
	Paragraph,
	Checkbox,
	Col,
	FieldWrapper,
	Heading,
	Input,
	Row,
	Svg,
	TertiaryButton,
	Text,
} from '@mlc/web-ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScreenSize } from '../../../enums';

export const FiltersWrapper = styled.div`
	position: static;
`;

export const FiltersMenuWrapper = styled.div`
	display: flex;
	justify-content: center;
	left: 0%;
	position: absolute;
	width: 100%;
`;

/*
	Outline when focused shows as black on Firefox which makes it look like there's no outline on the landing page
	The -moz-focusring bit matches the outline with the View Client Groups button (#0000FF = blue)
*/
export const FiltersButton = styled.button`
	align-items: center;
	background-color: transparent;
	border: 0;
	display: flex;
	justify-content: center;
	margin: 0 0 19px 0;
	overflow: visible;
	padding: 0;
	position: relative;
	width: 100%;

	&:focus,
	&:hover {
		cursor: pointer;
	}

	&:-moz-focusring {
		outline: 1px dotted #00f;
	}
`;

export const ArrowContainer = styled.div`
	align-items: center;
	clip: rect(0, 50px, 25px, 0);
	display: flex;
	height: 50px;
	justify-content: center;
	left: -12.5px;
	overflow: hidden;
	position: absolute;
	top: 90%;
	width: 50px;
`;

export const PopoutArrow = styled(CardToolkit)`
	background: ${palette.mlcWhite};
	height: 25px;
	transform: rotate(45deg);
	width: 25px;
	z-index: 3;
`;

export const FilterButtonLabel = styled(Paragraph)`
	margin: 0;

	${FiltersButton}:hover & {
		text-decoration: underline;
	}
`;

export const FilterDropdownPopoutContainer = styled.div`
	display: flex;
	justify-content: center;
	position: relative;
`;

export const FilterDropdownArrow = styled(FontAwesomeIcon)`
	margin: 3px 7px 0 7px;
`;

export const FilterMenuIcon = styled(FontAwesomeIcon)`
	line-height: 1em;
	margin-right: 7px;
`;

export const FilterButtonCountBackground = styled.span`
	align-items: center;
	background-color: ${palette.mlcAqua};
	border-radius: 1rem;
	justify-content: center;
	padding: 0.05rem 0.4rem;
	position: relative;
	text-decoration: none;
`;

export const FilterButtonCount = styled(Label)`
	color: ${palette.mlcWhite};
	font-size: 0.8rem;
	margin: 0;
`;

export const Card = styled(CardToolkit)`
	width: 100%;
`;

export const ValidatedInput = styled(Input)`
	color: ${props => (props.error ? palette.mlcError : palette.mlcText)};
`;

export const BottomFilterLabel = styled(FieldWrapper)`
	margin-bottom: 30px;

	label,
	legend {
		margin-bottom: 4px;
	}

	span,
	select {
		margin-bottom: 0;
	}
`;

export const CheckboxSubCol = styled(Col)`
	padding: 0 0 0 10px;

	div:last-child {
		margin-bottom: 0;
	}
`;

export const ErrorCol = styled(Col)`
	margin: 0;
	padding: 0;
`;

export const ErrorIcon = styled(FontAwesomeIcon)`
	margin-right: 10px;
`;

export const FieldWrapperRightSubCol = styled(Col)`
	padding: 0;

	.Select {
		margin-bottom: 0;
	}

	@media (min-width: ${ScreenSize.medium}) {
		padding: 0 0 0 5px;
	}
`;

export const FieldWrapperLeftSubCol = styled(Col)`
	padding: 0;

	.Select {
		margin-bottom: 0;
	}

	@media (min-width: ${ScreenSize.medium}) {
		padding: 0 5px 0 0;
	}
`;

export const FieldWrapperSubRow = styled(Row)`
	margin: 0;
`;

export const FilterCheckbox = styled(Checkbox)`
	.Checkbox__label {
		font-weight: normal;
	}
`;

export const FilterLabel = styled(FieldWrapper)`
	margin-bottom: 24px;

	label,
	legend {
		margin-bottom: 4px;
	}

	span,
	select {
		margin-bottom: 0;
	}
`;

export const LeftSubCol = styled(Col)`
	padding: 0 10px 0 10px;

	@media (min-width: ${ScreenSize.medium}) {
		padding: 0 5px 0 10px;
	}
`;

export const RightSubCol = styled(Col)`
	padding: 0 10px 0 10px;

	@media (min-width: ${ScreenSize.medium}) {
		padding: 0 10px 0 5px;
	}
`;

export const SingleSubCol = styled(Col)`
	padding: 0 10px 0 10px;
`;

export const MultiSelectHelper = styled(Text)`
	color: ${palette.mlcWallaby};
	font-size: 0.9em;
`;

export const SectionHeadingRow = styled(Row)`
	padding: 0;
`;

export const SectionHeading = styled(Heading)`
	margin: 0 0 17px 0;
`;

export const ValidationError = styled.div`
	color: ${palette.mlcError};
	margin: -20px 0 24px 0;
`;
